/*
  Take a function that expects varargs and turn it into a function that
  expects an array
*/
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const gather = (fn: (...args: Array<any>) => any) => (args: unknown) =>
  fn.apply(this, args);
// Take the complement of a function
export const complement =
  <T>(f: (arg0: T) => boolean): ((arg0: T) => boolean) =>
  (...args) =>
    !f(...args);
export const partial =
  (
    f: (...args: Array<any>) => any, // eslint-disable-line @typescript-eslint/no-explicit-any
    ...args: Array<unknown>
  ) =>
  (...otherArgs: Array<unknown>) =>
    f(...args, ...otherArgs);
export const compose =
  (
    ...fargs: Array<(...args: Array<any>) => any> // eslint-disable-line @typescript-eslint/no-explicit-any
  ) =>
  (...initArgs: Array<unknown>) =>
    fargs
      .slice(0, -1)
      .reduceRight((acc, f) => f(acc), fargs[fargs.length - 1](...initArgs));
// Takes a function f and returns another function that returns the
// values that f would return, but wrapped in a promise
export const wrapPromise =
  <T>(
    f: (arg0: any) => T // eslint-disable-line @typescript-eslint/no-explicit-any
  ) =>
  (
    ...args: any // eslint-disable-line @typescript-eslint/no-explicit-any
  ): Promise<T> =>
    // @ts-expect-error ts-migrate(2556) FIXME: Expected 1 arguments, but got 0 or more.
    Promise.resolve(f(...args));
export const identity = <T>(x: T): T => x;
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const defer = (fn: (...args: Array<any>) => any) => setTimeout(fn, 0);
